module.exports = {
	"config": {
		"siteTitle": "IRC",
		"linkPrefix": "/irc"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/julia/web/clients/irc/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.js",
				"ext": "js",
				"name": "404",
				"extname": ".js",
				"basename": "404.js",
				"dirname": "",
				"stem": "404",
				"path": "404.js",
				"absolute": "/Users/julia/web/clients/irc/404.js",
				"isAbsolute": false
			},
			"requirePath": "404.js",
			"path": "/404/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.js",
				"ext": "js",
				"name": "about",
				"extname": ".js",
				"basename": "about.js",
				"dirname": "",
				"stem": "about",
				"path": "about.js",
				"absolute": "/Users/julia/web/clients/irc/about.js",
				"isAbsolute": false
			},
			"requirePath": "about.js",
			"path": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "contact.js",
				"ext": "js",
				"name": "contact",
				"extname": ".js",
				"basename": "contact.js",
				"dirname": "",
				"stem": "contact",
				"path": "contact.js",
				"absolute": "/Users/julia/web/clients/irc/contact.js",
				"isAbsolute": false
			},
			"requirePath": "contact.js",
			"path": "/contact/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "events.js",
				"ext": "js",
				"name": "events",
				"extname": ".js",
				"basename": "events.js",
				"dirname": "",
				"stem": "events",
				"path": "events.js",
				"absolute": "/Users/julia/web/clients/irc/events.js",
				"isAbsolute": false
			},
			"requirePath": "events.js",
			"path": "/events/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/julia/web/clients/irc/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "review.js",
				"ext": "js",
				"name": "review",
				"extname": ".js",
				"basename": "review.js",
				"dirname": "",
				"stem": "review",
				"path": "review.js",
				"absolute": "/Users/julia/web/clients/irc/review.js",
				"isAbsolute": false
			},
			"requirePath": "review.js",
			"path": "/review/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 375
// module chunks = 0